import { Grid } from "modules/common/components/Grid";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { Flex, Link, Box, Image } from "@chakra-ui/react";
import type { AboutProps } from "./About.d";
import { headingStyles, textStyles } from "./About.styles";

const About = ({ heading, imageSrc, text, videoSrc }: AboutProps) => (
  <Grid mb={0} py={{ base: 14, lg: 24 }}>
    <Box gridColumn={{ base: "span 1", md: "span 12" }}>
      <Flex
        justify="space-between"
        flexDir={{ base: "column", lg: "row" }}
        alignItems={{ base: "flex-start", lg: "flex-end" }}
      >
        <RichtextAdapter content={heading} customStyles={headingStyles} />
      </Flex>
      <Flex justify={{ lg: "space-between" }} pt={{ base: 14, lg: 12 }} flexDir={{ base: "column", lg: "row" }}>
        <Flex flexDir="column" flexBasis={{ base: "auto", lg: "50vw" }}>
          <RichtextAdapter content={text} customStyles={textStyles} />
        </Flex>
        <Flex
          flexBasis={{ base: "auto", lg: "40vw" }}
          justify={{ base: "flex-start", md: "center", lg: "flex-end" }}
          align={{ base: "center", lg: "flex-start" }}
          pt={{ base: 12, lg: 0 }}
        >
          <Link
            href={videoSrc}
            isExternal
            cursor="pointer"
            w={{ base: "full", md: "unset" }}
            display="flex"
            justifyContent={{ base: "center", lg: "flex-end" }}
          >
            <Image src={imageSrc} minW={{ base: "100%", md: "368px" }} />
          </Link>
        </Flex>
      </Flex>
    </Box>
  </Grid>
);

export default About;
